import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Card, CardHeader, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, MenuItem, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { toast } from 'react-toastify';
import logo from '../Assests/paw.png'


export default function ItemDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {
    const inputRef = useRef(null);
    const [itemData, setItemData] = useState({
        itemName: "",
        itemCategoryID: 0,
        itemType: 0,
        itemRemark: "",
        status: true,
        sellingPrice: 0.0,
        isFavourite: false
    })
    const [categoryList, setCategoryList] = useState([]);
    const [img, setImg] = useState(null);
    const [previewImg, setPreviewImg] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isImageUpload, setIsImageUpload] = useState(false);

    useEffect(() => {
        GetAllActiveCategoryDetails();
    }, [])

    useEffect(() => {
        GetItemDetailByItemID();
    }, [updateID])

    function handleClose() {
        setDialogOpen(false);
        ClearData();
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setItemData({
            ...itemData,
            [e.target.name]: value
        })
    }

    function GetAllActiveCategoryDetails() {
        axios.get('https://serverfourpaws.ccsoftwares.com/Category/getallactivecategory').then((res) => {
            if (res.data.length > 0) {
                setCategoryList(res.data);
            }
        })
    }

    function GetItemDetailByItemID() {
        axios.get(`https://serverfourpaws.ccsoftwares.com/Item/getItemDetailByItemID/${updateID}`).then((res) => {
            //console.log("res.data:> ", res.data)
            if (res.data.length > 0) {
                setItemData({
                    ...itemData,
                    itemName: res.data[0].ItemName,
                    itemCategoryID: res.data[0].ItemCategoryID,
                    itemType: res.data[0].ItemTypeID,
                    itemRemark: res.data[0].ItemRemark,
                    status: res.data[0].IsActive == 1 ? true : false,
                    sellingPrice: res.data[0].sellingPrice,
                    isFavourite: res.data[0].isfavourite == 1 ? true : false,
                })
                setPreviewImg(res.data[0].ItemImage);
                setIsUpdate(true);
            }
        })
    }

    function ClearData() {
        setItemData({
            ...itemData,
            itemName: "",
            itemCategoryID: 0,
            itemType: 0,
            itemRemark: "",
            sellingPrice: 0.0,
            isFavourite: false,
            status: true
        })
        removeImage();
        setIsImageUpload();
    }

    const uploadImage = (e) => {
        setImg(e.target.files[0]);
        setPreviewImg(URL.createObjectURL(e.target.files[0]));
        setIsImageUpload(true);
    }

    function removeImage() {
        setImg(null);
        setPreviewImg(null);
        if (inputRef.current) {
            inputRef.current.value = null; // Reset the input value
        }
    }

    function handleStatusChange() {
        setItemData({
            ...itemData,
            status: !itemData.status
        })
    }

    function handleFavouriteChange() {
        setItemData({
            ...itemData,
            isFavourite: !itemData.isFavourite
        })
    }

    function UploadItem() {
        if (isUpdate) {
            const formData = new FormData();
            formData.append("updateID", updateID)
            formData.append("itemName", itemData.itemName.trim())
            formData.append("itemCategoryID", itemData.itemCategoryID)
            formData.append("itemType", itemData.itemType)
            formData.append("itemRemark", itemData.itemRemark.trim())
            formData.append("status", itemData.status ? 1 : 0)
            formData.append("sellingPrice", itemData.sellingPrice)
            formData.append("isFavourite", itemData.isFavourite ? 1 : 0)
            formData.append("previewImg", previewImg)
            formData.append("file", previewImg ? img : null)

            axios.put('https://serverfourpaws.ccsoftwares.com/Item/updateItem', formData).then((res) => {
                if (res.data.affectedRows > 0) {
                    handleClose();
                    setIsUpdate(false);
                    setUpdateID(0);
                    toast.success("Item Updated successfully!")
                }
            })
        } else {
            const formData = new FormData();
            formData.append("itemName", itemData.itemName.trim())
            formData.append("itemCategoryID", itemData.itemCategoryID)
            formData.append("itemType", itemData.itemType)
            formData.append("itemRemark", itemData.itemRemark.trim())
            formData.append("status", itemData.status ? 1 : 0)
            formData.append("sellingPrice", itemData.sellingPrice)
            formData.append("isFavourite", itemData.isFavourite ? 1 : 0)
            formData.append("previewImg", previewImg)
            formData.append("file", previewImg ? img : null)

            axios.post('https://serverfourpaws.ccsoftwares.com/Item/createItem', formData).then((res) => {
                if (res.data > 0) {
                    handleClose();
                    toast.success("Item Added successfully!");
                }
            })
        }
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {isUpdate ? 'Update Item' : 'Add Item'}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            itemName: itemData.itemName,
                            itemCategoryID: itemData.itemCategoryID,
                            itemType: itemData.itemType,
                            itemRemark: itemData.itemRemark,
                            sellingPrice: itemData.sellingPrice,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                itemName: Yup.string()
                                    .required('Item Name is required')
                                    .test('no-leading-space', 'Item Name cannot start with a space', value => value && value.trim().length > 0),
                                itemCategoryID: Yup.number()
                                    .required('Item Category is required')
                                    .test('valid-selection', 'Please select a valid item category', value => value !== 0),
                                itemType: Yup.number()
                                    .required('Item Type is required')
                                    .test('valid-selection', 'Please select a valid item type', value => value !== 0),
                            })
                        }

                        onSubmit={() => UploadItem()}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.itemName && errors.itemName)}
                                                        helperText={touched.itemName && errors.itemName}
                                                        onBlur={handleBlur}
                                                        label="Item Name *"
                                                        name='itemName'
                                                        value={itemData.itemName}
                                                        id='itemName'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        error={Boolean(touched.itemCategoryID && errors.itemCategoryID)}
                                                        helperText={touched.itemCategoryID && errors.itemCategoryID}
                                                        onBlur={handleBlur}
                                                        label="Item Category *"
                                                        name='itemCategoryID'
                                                        value={itemData.itemCategoryID}
                                                        id='itemCategoryID'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        <MenuItem key={0} value={0}>Select Item Category</MenuItem>
                                                        {categoryList.map((row) => (
                                                            <MenuItem key={row.CategoryID} value={row.CategoryID}>{row.CategoryID} - {row.CategoryName}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        error={Boolean(touched.itemType && errors.itemType)}
                                                        helperText={touched.itemType && errors.itemType}
                                                        onBlur={handleBlur}
                                                        label="Item Type *"
                                                        name='itemType'
                                                        value={itemData.itemType}
                                                        id='itemType'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        <MenuItem key={0} value={0}>Select Item Type</MenuItem>
                                                        <MenuItem key={1} value={1}>Liquid</MenuItem>
                                                        <MenuItem key={2} value={2}>Pills</MenuItem>
                                                        <MenuItem key={3} value={3}>Others</MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <Grid item md={12} xs={12}>
                                                        <TextField
                                                            fullWidth
                                                            error={Boolean(touched.sellingPrice && errors.sellingPrice)}
                                                            helperText={touched.sellingPrice && errors.sellingPrice}
                                                            onBlur={handleBlur}
                                                            label={
                                                                itemData.itemType === 1
                                                                    ? "Selling Price per 1 ml*"
                                                                    : itemData.itemType === 2
                                                                        ? "Selling Price per 1 pill *"
                                                                        : "Selling Price *"
                                                            }
                                                            name='sellingPrice'
                                                            value={itemData.sellingPrice}
                                                            id='sellingPrice'
                                                            onChange={(e) => handleChange(e)}
                                                            onFocus={() => {
                                                                setItemData((prev) => ({
                                                                    ...prev,
                                                                    sellingPrice: prev.sellingPrice === 0.0 ? "" : prev.sellingPrice,
                                                                }));
                                                            }}
                                                            inputProps={{
                                                                inputMode: 'decimal',
                                                                pattern: '^[0-9]*\\.?[0-9]{0,2}$',
                                                            }}
                                                            onKeyDown={(e) => {
                                                                const value = e.target.value;
                                                                const decimalIndex = value.indexOf('.');
                                                                if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== '.') {
                                                                    e.preventDefault();
                                                                }
                                                                if (e.key === '.' && decimalIndex !== -1) {
                                                                    e.preventDefault();
                                                                }
                                                                if (decimalIndex !== -1 && value.substring(decimalIndex + 1).length >= 2 && e.key !== 'Backspace' && e.key !== 'Delete') {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            variant="outlined"
                                                            size="small"
                                                            type='text'
                                                            InputLabelProps={{
                                                                sx: {
                                                                    color: itemData.itemType === 1 || itemData.itemType === 2 ? 'red' : 'inherit',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.itemRemark && errors.itemRemark)}
                                                        helperText={touched.itemRemark && errors.itemRemark}
                                                        onBlur={handleBlur}
                                                        label="Item Remark"
                                                        name='itemRemark'
                                                        value={itemData.itemRemark}
                                                        id='itemRemark'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                        multiline
                                                        rows={4}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item md={12} xs={12}>
                                                    <input
                                                        ref={inputRef}
                                                        type='file'
                                                        accept='image/*'
                                                        onChange={(e) => uploadImage(e)}
                                                        className='inputImage'
                                                        disabled={previewImg}
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                            border: '1px solid #ced4da',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#fff',
                                                            color: '#02847A',
                                                            outline: 'none',
                                                            boxShadow: 'none',
                                                            boxSizing: 'border-box',
                                                            height: 'auto'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    {isUpdate ?
                                                        <>
                                                            {isImageUpload ?
                                                                <>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <img
                                                                                src={previewImg}
                                                                                width='180px'
                                                                                height='180px'
                                                                                alt='item'
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={logo}
                                                                                width='180px'
                                                                                height='180px'
                                                                                alt='item'
                                                                            />
                                                                        }
                                                                    </center>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <IconButton>
                                                                                <CancelIcon
                                                                                    sx={{ color: 'red' }}
                                                                                    onClick={removeImage}
                                                                                />
                                                                            </IconButton>
                                                                            : null}
                                                                    </center>
                                                                </>
                                                                :
                                                                <>
                                                                    <center>
                                                                        {previewImg && isUpdate ?
                                                                            <img
                                                                                src={`https://serverfourpaws.ccsoftwares.com/Assets/Items/${previewImg}`}
                                                                                width='180px'
                                                                                height='180px'
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={logo}
                                                                                width='180px'
                                                                                height='180px'
                                                                            />
                                                                        }
                                                                    </center>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <IconButton>
                                                                                <CancelIcon
                                                                                    sx={{ color: 'red' }}
                                                                                    onClick={removeImage}
                                                                                />
                                                                            </IconButton>
                                                                            : null}
                                                                    </center>
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            <center>
                                                                {previewImg && !isUpdate ?
                                                                    <img
                                                                        src={previewImg}
                                                                        width='180px'
                                                                        height='180px'
                                                                    />
                                                                    :
                                                                    <img
                                                                        src={logo}
                                                                        width='180px'
                                                                        height='180px'
                                                                    />
                                                                }
                                                            </center>
                                                            <center>
                                                                {previewImg ?
                                                                    <IconButton>
                                                                        <CancelIcon
                                                                            sx={{ color: 'red' }}
                                                                            onClick={removeImage}
                                                                        />
                                                                    </IconButton>
                                                                    : null}
                                                            </center>
                                                        </>
                                                    }

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={6} xs={12} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                            <Typography>Active</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.status}
                                                onChange={handleStatusChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={6} xs={12} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                            <Typography>Is Favourite</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.isFavourite}
                                                onChange={handleFavouriteChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            {isUpdate ? null
                                                :
                                                <Button
                                                    variant="contained"
                                                    sx={{ width: '30%' }}
                                                    onClick={ClearData}
                                                >
                                                    clear
                                                </Button>
                                            }

                                            &nbsp; &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '30%' }}
                                            >
                                                {isUpdate ? 'Update' : 'Submit'}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </DialogContent>
        </Dialog >
    )
}
